import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/** The `AltDateTimeWidget` is an alternative widget for rendering datetime properties.
 *  It uses the AltDateWidget for rendering, with the `time` prop set to true by default.
 *
 * @param props - The `WidgetProps` for this component
 */
function AltDateTimeWidget(_a) {
    var { time = true } = _a, props = __rest(_a, ["time"]);
    const { AltDateWidget } = props.registry.widgets;
    return _jsx(AltDateWidget, Object.assign({ time: time }, props));
}
export default AltDateTimeWidget;
//# sourceMappingURL=AltDateTimeWidget.js.map